import React from 'react';
import { Logo } from './ui/Logo';
export function Footer() {
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const links = [{
    name: 'How It Works',
    id: 'how-it-works'
  }, {
    name: 'Platform',
    id: 'platform'
  }, {
    name: 'Use Cases',
    id: 'use-cases'
  }, {
    name: 'Team',
    id: 'team'
  }];
  return <footer className="bg-hubble-bg border-t border-hubble-border pt-16 pb-8 relative z-10" data-id="element-17">
      <div className="max-w-7xl mx-auto px-6" data-id="element-18">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 mb-12" data-id="element-19">
          <Logo data-id="element-20" />

          <nav className="flex flex-wrap justify-center items-center gap-6 md:gap-8" data-id="element-21">
            {links.map((link, i) => <a key={i} href={`#${link.id}`} onClick={e => scrollToSection(e, link.id)} className="font-body text-sm text-hubble-body hover:text-hubble-text transition-colors" data-id="element-22">
                {link.name}
              </a>)}
          </nav>
        </div>

        <div className="pt-8 border-t border-hubble-border/50 flex flex-col items-center justify-center" data-id="element-23">
          <p className="font-body text-sm text-hubble-body" data-id="element-24">
            © 2026 Hubble. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}